// src/components/Navbar.jsx
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function Navbar() {
  console.log("AuthContext value:", useContext(AuthContext));

  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      
      {/* Logo */}
      <Link to="/" className="nav-brand">
        <img src="/media/logo.png" alt="Namaste Logo" className="nav-logo" />
        <span className="nav-title">Namaste Restaurant & Bar</span>
      </Link>

      {/* Desktop Links */}
      <div className={`nav-links ${open ? "open" : ""}`}>
        <Link to="/" onClick={() => setOpen(false)}>Home</Link>
        <Link to="/menu" onClick={() => setOpen(false)}>Menu</Link>
        <Link to="/order" onClick={() => setOpen(false)}>Order</Link>

        {user ? (
          <button className="nav-logout-btn" onClick={() => { logout(); setOpen(false); }}>
            Logout ({user.name})
          </button>
        ) : (
          <Link to="/login" onClick={() => setOpen(false)}>
            Login
          </Link>
        )}
      </div>

      {/* Mobile Toggle */}
      <div className="nav-toggle" onClick={() => setOpen(!open)}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

    </nav>
  );
}

export default Navbar;
